import {InputText} from "./InputText";

export const TAN_LENGTH = 6;

export const sanitizeTan = (value) => (value || "").replace(/\D/g, "").slice(0, TAN_LENGTH);

export const isValidTan = (value) => new RegExp(`^\\d{${TAN_LENGTH}}$`).test(value || "");

export const TanInput = ({value, setter, name = "tan", label = "Code", required = true, ...props}) => {
    return <InputText name={name}
                      label={label}
                      value={value}
                      setter={newValue => setter(sanitizeTan(newValue))}
                      required={required}
                      inputMode="numeric"
                      autoComplete="one-time-code"
                      maxLength={TAN_LENGTH}
                      pattern={`[0-9]{${TAN_LENGTH}}`}
                      title={`Bitte geben Sie genau ${TAN_LENGTH} Ziffern ein.`}
                      {...props}/>;
}
